import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PlatformType, PlatformParams, PlatformInfo } from './types';

interface PlatformContextType {
  platformInfo: PlatformInfo;
  setPlatformInfo: (type: PlatformType, params: PlatformParams) => void;
  clearPlatformInfo: () => void;
}

const PlatformContext = createContext<PlatformContextType | undefined>(undefined);

export const PlatformProvider = ({ children }: { children: ReactNode }) => {
  const [platformInfo, setPlatformInfoState] = useState<PlatformInfo>({
    type: null,
    params: null,
  });

  const setPlatformInfo = (type: PlatformType, params: PlatformParams) => {
    setPlatformInfoState({ type, params });
  };

  const clearPlatformInfo = () => {
    setPlatformInfoState({ type: null, params: null });
  };

  return (
    <PlatformContext.Provider value={{ platformInfo, setPlatformInfo, clearPlatformInfo }}>
      {children}
    </PlatformContext.Provider>
  );
};

export const usePlatformContext = () => {
  const context = useContext(PlatformContext);
  if (context === undefined) {
    throw new Error('usePlatformContext must be used within a PlatformProvider');
  }
  return context;
};
